// extracted by mini-css-extract-plugin
export default {"radioGroupLabel":"ChangeFormField__radioGroupLabel--p_T","captcha":"ChangeFormField__captcha--2mm","textLabel":"ChangeFormField__textLabel--1Tp"};